<template>
  <div class="work_wrap" id="targetbox">
	  <div class="work_back flex">
	  	<span class="work_backtext" @click="backJob"> < 返回上一步</span>
	  	<div class="work_backicon" @click="backJob">
	  		<span class="el-icon-arrow-left"></span>
        <span style="font-size: 16px;">返回上一步</span>
	  	</div>
	  </div>
    <div class="font18 work_font2">申请职位</div>
    <el-form ref="queryParams" :model="queryParams" :rules="rules" label-position="top">
      <el-upload
        class="upload-demo"
        drag
        :action="uploadPath + '?type=303'"
        multiple
		:on-success="handleGalleryUrl"
		:on-remove="handleRemove">
        <div v-if="resumeFileList.length==0" class="upload_inner">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text work_font3">
            <span class="big_dialog">拖拽或</span>
            <em>点击上传</em>简历，让我们快速了解你~ </div>
          <div class="el-upload__text">支持doc、docx、pdf、html、htm、txt、rtf、mht、eml、wps、jpeg、jpg、png、ppt、pptx格式文件上传，最大不超过50M</div>

        </div>
        <div v-else class="upload_continue">继续上传</div>
      </el-upload>
      <div class="font18 work_font1">个人信息</div>
      <el-form-item label="姓名" prop="userName">
        <el-input v-model="queryParams.userName" placeholder="请输入姓名"
		 clearable size="large" style="width: 100%" maxlength="20" />
      </el-form-item>
      <el-form-item label="申请职位" prop="work">
        <template v-if="windowWidth>480">
          <el-select style="width: 100%;" @change="selectWork" v-model="queryParams.work" placeholder="请选择">
            <el-option
              v-for="(item, index) in jobTypeList"
              :key="item.jobId"
              :label="item.jobName"
              :value="item.jobId">
            </el-option>
          </el-select>
        </template>
        <!-- <el-input v-if="windowWidth>480" v-model="queryParams.work" placeholder="请输入申请职位" clearable size="large" style="width: 100%" maxlength="20" /> -->
        <div class="work_name flexbet" v-else @click="showJoblist=true">
          <div v-if="jobName">{{jobName}}</div>
          <div class="work_nametext" v-else>请输入申请职位</div>
          <span class="el-icon-arrow-down"></span>
        </div>
	  </el-form-item>
      <el-form-item label="联系电话" prop="userMobile">
        <el-input v-model.number="queryParams.userMobile" placeholder="请输入联系电话"
		 clearable size="large" style="width: 100%" maxlength="11" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="queryParams.email" placeholder="请输入邮箱" clearable size="large" style="width: 100%" maxlength="20" />
      </el-form-item>
    </el-form>
    <div class="delivery_down font18 flex">
      <div class="applybtn cancelbtn" @click="backJob">取消</div>
      <div class="applybtn confirmbtn" @click="submitJob">提交</div>
    </div>
    <el-dialog
      title=""
      :show-close="false"
      :visible.sync="dialogVisible">
      <div class="apply_dialog flexcenter flexcolumn">
        <img class="apply_img" :src="require('../../../../assets/image/delivery_success.png')" />
        <p class="apply_font1">投递成功</p>
        <p class="apply_font2">请等待公司人事的面试邀约</p>
        <div class="apply_confirm font18" @click="confirmVisible">好 的</div>
      </div>
    </el-dialog>

	<van-popup v-model="showJoblist" position="bottom">
		<van-picker v-if="columnsJob.length>0" show-toolbar :columns="columnsJob"
		 @confirm="onConfirmjobtype" @cancel="showJoblist=false"/>
	</van-popup>
  </div>
</template>

<script>
	import { jobPageListapi, uploadPath,sendResumeapi } from "@/api/apilist/commonApi";
  export default {
    data() {
      return {
        showJoblist: false,
        columnsJob: [],
        uploadPath,
        jobId: '',
        jobName: '',
        dialogVisible: false,
        queryParams: {
          pageNum: 1,
          pageSize: 6,
          userName: undefined,
          work: undefined,
          userMobile: undefined,
          email: undefined,
          mediaName: undefined, // 素材名称
          mediaSuffix: undefined, // 素材格式后缀(png、jpg、jpeg、gif、mp4、avi、rmvb)
          mediaType: 1, // 素材类型(1图片 2视频)
        },
        // 表单校验
        rules: {
          userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          work: [{ required: true, message: "请输入申请职位", trigger: ["change", "blur"] }],
          userMobile: [
            { required: true, message: "请输入联系电话", trigger: "change" },
            { type: 'number', message: '电话必须为数字'}
                ],
                email: [{ required: true, message: "请输入邮箱", trigger: "blur" },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]
        },
        resumeFileList: [],
        jobTypeList: [],
        dialogWidth: 700+'',
      };
    },
    props: {
      jobInfo:{
        type: Object,
        default: ()=>{}
      },
      backValue: {
        type: Number,
        default: 0,
      },
      windowWidth: {
        type: Number,
        default: 1200,
      }
    },
    created() {
      this.$nextTick(() => {
        setTimeout(() => {
          let targetbox = document.getElementById('targetbox');
          document.documentElement.scrollTop = targetbox.offsetTop;
        },100)
      })
      if(this.windowWidth>480){
        this.dialogWidth = 700+'';
      }else{
        this.dialogWidth = 300+'';
      }
      this.queryParams.work = this.jobInfo.jobId;
      this.jobId = this.jobInfo.jobId;
      this.jobName = this.jobInfo.jobName;
      this.getjobPageList();
    },
    methods:{
      selectWork(e){
        console.log('看看这个呢',e)
      },
      backJob(){
        this.$emit('backJob', this.backValue)
      },
		// 上传成功
		handleGalleryUrl(response, file, fileList) {
      console.log('response, file, fileList', response, file, fileList)
			let that = this;
			if (response.code === 200) {
				let mystr = response.data.name;
				let fileType = mystr.substring(mystr.length-3, mystr.length);
			  that.resumeFileList.push({fileType: file.name,fileUrl: response.data.url});
			} else {
				that.$message.warning('部分文件上传失败，请重新上传');
				that.resumeFileList = [];
			}
		},
		// 删除文件
		handleRemove(file, fileList) {
		  for (var i = 0; i < this.resumeFileList.length; i++) {
		    var url;
		    if (file.response === undefined) {
		      url = file.url
		    } else {
		      url = file.response.data.url
		    }
		    if (this.resumeFileList[i].url === url) {
		      this.resumeFileList.splice(i, 1)
		    }
		  }
		},
		submitJob(){
			this.$refs["queryParams"].validate((valid) => {
				if (valid) {
					if(this.resumeFileList.length==0){
						this.$message.warning('请上传文件！');
						return false
					}
					sendResumeapi({
						jobId: this.jobId,
						resumeFileList: this.resumeFileList,
						userEmail: this.queryParams.email,
						userMobile: this.queryParams.userMobile,
						userName: this.queryParams.userName,
					}).then(res=>{
						this.dialogVisible = true;
				})
				}
			})
		},
    confirmVisible(){
      this.dialogVisible = false;
      this.$emit('backJob', 0, true)
    },
		onConfirmjobtype(val){
			this.jobTypeList.forEach((item)=>{
				if(val==item.jobName){
					this.jobId = item.jobId;
					this.jobName = item.jobName
				}
			})
			this.showJoblist = false;
		},
		getjobPageList() {
			jobPageListapi({
				pageNum: 1,
				pageSize: 10,
				publishTimeCode: 1,
				typeId: '',
			}).then(res=>{
				if(res.data.list.length>0){
					this.columnsJob = [];
					res.data.list.forEach((item)=>{
						this.columnsJob.push(item.jobName)
					})
					this.jobTypeList = res.data.list;
				}
			})
		},
    }
  }
</script>

<style scoped lang="less">
	@media screen and (max-width: 480px){
    .big_dialog{display: none;}
    ::v-deep .el-dialog{width: 330px;}
    .upload-demo ::v-deep .el-upload{background-color: #f2f2f2;}
    .upload-demo ::v-deep .el-upload-list{margin-top: 20px;}
    .upload-demo ::v-deep .el-icon-close{top: 0px;}
    ::v-deep .el-upload-list__item{line-height: 40px;}
    ::v-deep .el-form-item__label{line-height: 20px;}
    .applybtn{width: 48%;border-radius: 5px;}
    ::v-deep .el-upload__text{font-size: 14px;}
    ::v-deep .el-upload-dragger{height: auto;padding: 0;}
    ::v-deep .el-upload-dragger .el-icon-upload{margin-top: 20px;}
    .upload-demo{height: auto;
      ::v-deep .el-upload-list__item .el-icon-upload-success{font-size: 22px;}
       ::v-deep .el-upload-list__item .el-icon-close{font-size: 22px;padding: 10px 0 10px 20px;}
      .upload_continue{
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        border: 1px solid #54A0FF;
        color: #54A0FF;
        text-align: center;
        font-size: 16px;
        background-color: #fff;
      }
      .upload_inner{
        padding: 10px 15px 35px;
      }
    }
    .delivery_down{margin: 30px 0;}

		.work_back{
			.work_backicon{font-size: 20px;padding: 10px 30px 10px 0px;margin-left: -5px;}
			.work_backtext{display: none;}
		}
		.font18{font-size: 16px;}
		.work_wrap{
		  padding-top: 10px;
		  font-size: 14px;
		}
		.work_font2{border-bottom: 1px solid #F2F2F2;margin-top: 10px;padding-bottom: 14px;}
		.work_name{
			width: 100%;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
			padding: 0 15px;
			.work_nametext{color: #999;}
		}
    .apply_dialog{
      padding: 0;
      .apply_img{
        width: 140px;
      }
      .apply_font1{
        font-size: 18px;
        margin: 20px 0 5px;
      }
      .apply_font2{
        font-size: 16px;
      }
      .apply_confirm{
        width: 100%;
        height: 40px;
        border-radius: 20px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        background-color: #4C94F8;
        margin-top: 25px;
      }
    }
	}
	@media screen and (min-width: 481px){
    .upload_continue{
      width: 300px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #4C94F8;
      color: #4C94F8;
      border-radius: 20px;
      margin: 40px auto;
    }
    .work_back{
    		.work_backicon{display: none;}
    	}
    .font18{font-size: 18px;}
    .applybtn{width: 120px;border-radius: 20px;}
    ::v-deep .el-dialog{width: 700px;}
    ::v-deep .el-upload__text{font-size: 18px;}
    ::v-deep .el-upload-dragger{height: auto;padding: 30px 0;}
    ::v-deep .el-upload-list{
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 0 auto;
      padding-bottom: 30px;
    }
    ::v-deep .el-upload-list__item:first-child{margin-top: 5px;margin-left: 0;}
    ::v-deep .el-upload-list__item{width: auto;font-size: 18px;margin-left: 30px;}
    .upload-demo{position: relative;
      background-color: #F2F2F2;}
    .delivery_down{margin: 50px 0 105px;}
    .upload_inner{padding-bottom: 40px;}
		.work_wrap{
		  padding-top: 100px;
		  font-size: 16px;
		}
		.work_font2{border-bottom: 1px solid #C2C2C2;margin-top: 46px;padding-bottom: 14px;}
    .apply_dialog{
      padding: 53px 0 83px;
      .apply_img{
        width: 174px;
        height: 160px;
      }
      .apply_font1{
        font-size: 30px;
        margin: 20px 0 5px;
      }
      .apply_font2{
        font-size: 20px;
      }
      .apply_confirm{
        width: 300px;
        height: 40px;
        border-radius: 20px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        background-color: #4C94F8;
        margin-top: 25px;
      }
    }
	}
  ::v-deep .el-dialog{border-radius: 20px;background-color: #F2F2F2;}
  .font18{font-weight: bold;}
  .work_wrap{
    .upload-demo{
      width: 100%;
      margin-top: 20px;
      .work_font3{font-weight: bold;margin-bottom: 10px;}
      ::v-deep .el-upload-dragger{
        background-color: #F2F2F2;
        border: none;
        width: 100%;
      }
	  ::v-deep .el-upload{display: block;}

    }
    .cancelbtn{
      color: #DCC691;
      margin-right: 20px;
    }
    .confirmbtn{
      color: #fff;
      background-color: #DCC691;
    }
    .applybtn{
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid #DCC691;
      cursor: pointer;
    }
    .work_content{line-height: 50px;}

    .work_font1{margin: 50px 0 14px;}
    .work_back{
      color: #D9BF81;
      cursor: pointer;

    }
	::v-deep .el-form-item__label{font-weight: bold;}
  }
</style>
